import type { QueryClient } from '@tanstack/react-query';
import { configurationQueryKey, sessionGroupsQueryKey } from './keys';

export const invalidateWorkspaceSessionQueries = (
  queryClient: QueryClient,
  sessionIds?: number[]
) => {
  if (sessionIds?.length) {
    sessionIds.forEach(sessionId => {
      void queryClient.invalidateQueries({
        queryKey: configurationQueryKey(String(sessionId)),
      });
    });
  } else {
    void queryClient.invalidateQueries({ queryKey: ['configuration'] });
  }

  void queryClient.invalidateQueries({ queryKey: sessionGroupsQueryKey() });
};
